import routes from 'src/config/api.routes';
import axiosService from './axiosService';

class TasksService {
  getTasks = async filter => axiosService.get(`${routes.tasks}${filter}`);

  getTask = async taskId => axiosService.get(`${routes.tasks}/${taskId}`);

  updateTask = async (taskDTO, taskId) => axiosService.put(`${routes.tasks}/${taskId}`, taskDTO);

  getAsignees = async () => axiosService.get(`${routes.tasks}/Assignees`);

  deleteTask = async taskId => axiosService.delete(`${routes.tasks}/${taskId}`);

  getPendingTasks = async () => axiosService.get(`${routes.tasks}/pending-tasks`);

  singleTaskAttachments = async completeTaskDTO => axiosService.post(
      `${routes.tasks}/single-task-attachments`,
      completeTaskDTO
    );

  completeTask = async completeTaskDTO => axiosService.post(`${routes.tasks}/complete-task`, completeTaskDTO);

  assignSingleTasks = async unassignedSingleTaskDTO => axiosService.post(`${routes.tasks}/assign-tasks`, unassignedSingleTaskDTO);
}

const tasksService = new TasksService();

export default tasksService;
